import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-unused-vars
  const swiperMember = new Swiper('.swiper-container-member', {
    slidesPerView: 1,
    threshold: 1,
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination-team-member',
      type: 'bullets',
      dynamicMainBullets: 3,
    },
    breakpoints: {
      699: {
        slidesPerView: 2,
        threshold: 2,
        slidesPerGroup: 2,
        spaceBetween: 24,
      },
      991: {
        slidesPerView: 3,
        threshold: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
      },
    },
  });
  // eslint-disable-next-line no-unused-vars
  const swiperArticle = new Swiper('.swiper-container-article', {
    slidesPerView: 3,
    threshold: 3,
    slidesPerGroup: 3,
    spaceBetween: 24,
    navigation: {
      nextEl: '.swiper-button-next-article',
      prevEl: '.swiper-button-prev-article',
    },
    pagination: {
      el: '.swiper-pagination-article',
      type: 'bullets',
      dynamicMainBullets: 3,
    },
    breakpoints: {
      699: {
        slidesPerView: 3,
        threshold: 3,
        slidesPerGroup: 3,
        spaceBetween: 24,
      },
    },
  });
  if (window.matchMedia('(max-width: 699px)').matches) {
    swiperArticle.destroy();
  }
});
